import { useSelector } from 'react-redux';

/**
 * Мова інтерфейсу: 'ua' або 'en'.
 *
 * Компоненти беруть її звідси, а не з localStorage, — інакше зміна мови не
 * доходила б до вже намальованого екрана.
 */
export function useLanguage() {
  return useSelector((state) => state.language);
}
